var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"no-margins goBackAtTop"},[_c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.goBack()}}},[_c('v-icon',[_vm._v("$sl-arrow-left")]),_vm._v(_vm._s(_vm.goBackLabel)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }